import React, { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import useLocalStorage from '../hooks/useLocalStorageTX2'
import Login from './Login'
import { Form } from '../Types/models/team'
import { fetchWithBaseUrl } from '../../utils/api'

export default function FormContainer({
	teamSlug,
	formId,
	formSchema,
	platform,
	formData,
	setFormData,
}: {
	teamSlug: string
	formId: string
	formSchema: Form
	setIsLoginDialogOpenContainer?: Function
	platform: string
	formData: {
		[formFieldId: string]: any
	} | null
	setFormData: React.Dispatch<
		React.SetStateAction<{
			[formFieldId: string]: any
		}>
	>
}) {
	const [isTOSAccepted, setIsTOSAccepted] = useState<boolean>(false)
	const [missingFormField, setMissingFormField] = useState<string | undefined>(
		undefined
	)
	const [invalidFormField, setInvalidFormField] = useState<string | undefined>(
		undefined
	)
	const auth = useAuth()
	const [isLoginVisible, setIsLoginVisible] = useState<Boolean>(false)
	const [selectedTeamId, setSelectedTeamId] = useLocalStorage<string>(
		'teamIdDashboard',
		''
	) // ??

	const [isClient, setIsClient] = useState(false)

	useEffect(() => {
		setIsClient(true)
	}, [])

	useEffect(() => {
		if (formSchema) {
			if (!formData) {
				let _formData: { [key: string]: any } = {}

				// Set default start time

				// Set default formFieldOptionId
				if (formSchema?.formFields) {
					let formFields: { [formFieldId: string]: string } = {}
					for (const [key, value] of Object.entries(
						formSchema?.formFields ?? {}
					)) {
						if (value.defaultFormFieldOptionId) {
							_formData[key] = value.defaultFormFieldOptionId
						}
					}
				}
				setFormData?.(_formData)
			} else {
			}
		}
	}, [formSchema, formId])

	useEffect(() => {
		validate()
	}, [formData, formSchema])

	const validate = () => {
		var isAllFormFieldValid = true
		for (const [key, value] of Object.entries(formSchema?.formFields ?? {})) {
			if (value.hidden == true) {
				continue
			} else if (value.mandatory && !formData?.[key]) {
				setMissingFormField(value.name)
				isAllFormFieldValid = false
			} else if (value.regex && formData?.formFields?.[key]) {
				let regex = new RegExp(value.regex)
				if (!regex.test(formData?.formFields?.[key] ?? '')) {
					setInvalidFormField(value.name)
					setMissingFormField(undefined)
					isAllFormFieldValid = false
				}
			}
		}
		if (isAllFormFieldValid) {
			setMissingFormField(undefined)
			setInvalidFormField(undefined)
		}
	}

	if (isLoginVisible) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Login
					completion={(userDTO) => {
						if (userDTO) {
							const organizations = userDTO.teams
							if (
								organizations &&
								Object.keys(organizations).length > 0 &&
								!selectedTeamId
							) {
								const teamId = Object.keys(organizations)[0]
								setSelectedTeamId(teamId)
							}
						}
						setIsLoginVisible(false)
					}}
					platform={'wordpress'}
					createTeamIfNotExist={false}
				/>
			</div>
		)
	} else {
		return (
			<>
				<div className={'row'}>
					{formSchema?.formFields &&
						Object.entries(formSchema?.formFields ?? {})
							.filter(
								([k, v]) =>
									(!v.planId || v.planId == formData?.pricingOptionId) &&
									v.hidden != true
							)
							.sort((a, b) => (a[1].ind ?? 0) - (b[1].ind ?? 0))
							.map(([key, value]) => (
								<div
									key={key}
									className="col-lg-6 form-box-item"
									style={{ display: 'flex', flexDirection: 'column' }}
								>
									<p style={{ flexGrow: 1 }}>
										{value.name ?? ''}
										{value.mandatory && (
											<span style={{ color: 'red' }}>{' *'}</span>
										)}
									</p>
									{value.details && (
										<p className="form-item-detail">{value.details ?? ''}</p>
									)}
									{value.type == 'selectItem' ? (
										<select
											onChange={(
												event: React.ChangeEvent<HTMLSelectElement>
											) => {
												setFormData({ ...formData, [key]: event.target.value })
											}}
											value={
												formData?.[key] != undefined
													? formData?.[key]
													: formSchema?.formFields?.[key]
															.defaultFormFieldOptionId ?? ''
											}
											className={'input-select'}
										>
											{value.options &&
												Object.entries(value.options).map(([key2, value2]) => (
													<option key={key2} value={key2}>
														{value2.name ?? ''}
													</option>
												))}
											{formSchema?.formFields?.[key]
												.defaultFormFieldOptionId ?? (
												<option key={'empty'}> </option>
											)}
										</select>
									) : value.type == 'textField' ? (
										<input
											className={'input-text'}
											onChange={(
												event: React.ChangeEvent<HTMLInputElement>
											) => {
												setFormData({ ...formData, [key]: event.target.value })
											}}
											value={
												formData?.[key] != undefined ? formData?.[key] : ''
											}
										/>
									) : value.type == 'switchItem' ? (
										''
									) : (
										''
									)}
								</div>
							))}
				</div>
				<div style={{ marginTop: '30px' }}>
					<input
						type="checkbox"
						style={{ marginRight: '16px' }}
						onClick={(event: React.MouseEvent<HTMLInputElement>) => {
							setIsTOSAccepted(event.currentTarget.checked)
						}}
						defaultChecked={isTOSAccepted}
						data-cy="tos-accept"
					/>
					<span>
						Igen, a Tikex.com{' '}
						<a
							href="https://tikex.com/aszf"
							style={{ textDecoration: 'underline' }}
						>
							üzletszabályzatot
						</a>{' '}
						elolvastam és elfogadom.
						<span style={{ color: 'red' }}>{' *'}</span>
					</span>
				</div>
				<div>
					{/*NOTE: Change it, in plugin also need check first user is on waitinglist */}
					{!auth?.userDTO && (
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							style={{ marginTop: '35px', marginRight: '35px' }}
							onClick={() => {
								if (platform == 'wordpress') {
									setIsLoginVisible(true)
								} else {
									window.location.replace(
										`/login?dst=${window.location.pathname.replace('/', '')}`
									)
								}
							}}
						>
							Bejelentkezés
						</a>
					)}
					{
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							style={{
								marginTop: '35px',
								width: '250px',
								marginRight: '35px',
							}}
							onClick={async () => {
								if (missingFormField || invalidFormField) {
									alert(
										missingFormField
											? `Töltsd ki az összes kötelező mezőt! pl. ${missingFormField}`
											: invalidFormField
											? `Töltsd ki helyesen a mezőket! pl. ${invalidFormField}`
											: `Olvasd el és fogadd el az üzletszabályzatot!`
									)
								} else {
									let headers: {
										[key: string]: string
									} = {
										'Content-Type': 'application/json',
									}
									if (auth?.userDTO?.token) {
										headers['Authorization'] = `Bearer ${auth?.userDTO?.token}`
									}
									const response = await fetchWithBaseUrl('saveForm', {
										method: 'POST',
										headers,
										body: JSON.stringify({ teamSlug, formId, formData }),
									})
									if (response.ok) {
										alert('Jelentkezésed rögzítettük')
										setFormData({})
									}
								}
							}}
							data-cy="forward-to-payment"
						>
							Mentés
						</a>
					}
				</div>
			</>
		)
	}
}
